import useRouterHistoryStore from 'stores/useRouterHistoryStore'
import useQueryContext from './useQueryContext'
import useRealm from './useRealm'

//nextjs don't provide route history out of the box.
//we store only 4 last routes
export default function useRouterHistory() {
  const { fmtUrlWithCluster } = useQueryContext()
  const { symbol } = useRealm()
  const history = useRouterHistoryStore((s) => s.history)

  const getLastRoute = () => {
    if (history.length) {
      return history[history.length - 1]
    } else {
      //if we have dao symbol we will redirect to dao home page
      return fmtUrlWithCluster(`/dao/`)
    }
  }
  return {
    history,
    getLastRoute,
  }
}
